import { IconCube, Stack } from '@vtex/admin-ui'
import { FormState } from '@vtex/admin-ui-form'
import { useProducts } from 'hooks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { DefaultProps } from 'typings'
import { MultiSelect } from '../../../MultiSelect'
import { DownloadButton } from '../DownloadButton'
import { ImportButton } from '../ImportButton'
import { SelectorHeader } from '../SelectorHeader'
import messages from './messages'
import { LIMITS } from 'shared'

interface ProductsSelectorProps {
  name: string
  state?: FormState
  loading?: boolean
  placeholder?: string
}

function Header(props: DefaultProps) {
  const { children } = props

  const { $t } = useIntl()

  return (
    <SelectorHeader label={$t(messages.label)} Icon={IconCube}>
      {children}
    </SelectorHeader>
  )
}

function Selector(props: ProductsSelectorProps) {
  const { name, state, placeholder, loading } = props

  const { $t } = useIntl()

  const [searchTerm, setSearchTerm] = useState('')

  const { data: products, isLoading } = useProducts({ searchTerm })

  return (
    <MultiSelect
      name={name}
      options={products?.items ?? []}
      label={placeholder ?? $t(messages.placeholder)}
      loading={loading}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
      state={state}
      maxEntries={LIMITS.MAX_PRODUCTS}
    />
  )
}

export function ProductsSelector(props: DefaultProps) {
  return (
    <Stack space="$space-2" fluid>
      {props.children}
    </Stack>
  )
}

ProductsSelector.Header = Header
ProductsSelector.Download = DownloadButton
ProductsSelector.Upload = ImportButton
ProductsSelector.Selector = Selector
